
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'


export default {
components: {
XHeader,
Flexbox,
FlexboxItem,
Icon
},
data () {
return {
tenkiId: '',
tenkiData: [],
hourData: [],
chartPoint: '',
chartCircle: [],
chartParams: {
width: 300,
height: 40,
stepWidth: 30,
leftWidth: 15
},
title: '',
warning: null
};
},
created () {
this.tenkiId = this.$route.params.id;
this.chartParams.width = window.innerWidth - 60;
this.chartParams.stepWidth = Math.floor(this.chartParams.width / 10);
this.chartParams.leftWidth = Math.floor(this.chartParams.stepWidth / 2);
this.loadData();
},
methods: {
loadData () {
const self = this;
self.$vux.loading.show({ text: 'Loading' });
self.$http.get('./static/phpapi/weather.php', {params: {id: self.tenkiId}})
.then((resp) => {
self.title = resp.data.title;
self.warning = resp.data.warn || null;
self.tenkiData = resp.data.d10.map((data, idx) => {
data.expand = idx === 0;
return data;
});

self.hourData = resp.data.h1.today.map((data) => {
data.type = 'today';
return data;
}).concat(resp.data.h1.tomorrow.map((data) => {
data.type = 'tomorrow';
return data;
})).slice(0, 10);

let tmpPoint = [];
let tmpValue = self.hourData.map((data) => {
return data.temp;
});
let maxValue = Math.max.apply(null, tmpValue);
let minValue = Math.min.apply(null, tmpValue);
let baseLineValue = minValue < 0 ? (maxValue < 0 ? 0 : 15) : 30;
let baseStepValue = Math.floor(30 / (maxValue - minValue <= 1 ? 2 : (maxValue - minValue)));
self.hourData.forEach((data, idx) => {
let x = idx * self.chartParams.stepWidth + self.chartParams.leftWidth;
let y = 5 + (baseLineValue - (parseInt(data.temp) - minValue) * baseStepValue);
tmpPoint.push(`${x},${y}`);
self.chartCircle.push({
x: x,
y: y,
v: data.temp
});
});
self.chartPoint = tmpPoint.join(' ');
})
.catch((err) => console.error(err))
.then(() => self.$vux.loading.hide());
}
}
};



// WEBPACK FOOTER //
// ./src/components/weather/Tenki.vue